import { FC, useEffect, useState } from 'react'
import { PagedResponseModel } from '../../../../models/responses/PagedResponseModel'
import { IPaginationFilter } from '../../../../models/requests/PaginationFilter'
import { GenericTable } from '../../../components/tables/GenericTable'
import { TableHelperButtons } from '../../../components/buttons/TableHelperButtons'
import { TableHelperButtonEnum } from '../../../enums/TableHelperButtonEnum'
import { IDescendingTopicsModel } from '../../../../models/responses/TopicModel'
import TopicApi from '../../../../infrastructure/api/TopicApi'
import UserApi from '../../../../infrastructure/api/UserApi'
import { IUserDictionaryModel } from '../../../../models/responses/UserDictionaryModel'
import { Link } from 'react-router-dom'
import { SelectModel } from '../../../models/SelectModel'
import { RootState } from '../../../../setup'
import { useSelector, shallowEqual, useDispatch } from 'react-redux'
import LevelApi from '../../../../infrastructure/api/LevelApi'
import * as level from '../../../pages/levels/redux/LevelRedux'

type Props = {
  onClickItem: (itemId: any, itemName: string, type: string) => void
  refresh: number
}

const DescendingTopicListModal: FC<Props> = ({ onClickItem, refresh }) => {
  const [descendingTopics, setDescendingTopics] = useState<PagedResponseModel<IDescendingTopicsModel[]>>()
  const [users, setUsers] = useState<IUserDictionaryModel[]>([])
  const levelDictionary: SelectModel[] = useSelector<RootState>(({ level }) => level.levelDictionary, shallowEqual) as SelectModel[]


  const [pageNumber, setPageNumber] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [searchText, setSearchText] = useState('')
  const [sort, setSort] = useState('date_asc')
  const dispatch = useDispatch()

  async function init() {
    const paginationFilter: IPaginationFilter = {
      page: pageNumber,
      size: pageSize,
      orderBy: sort,
      search: searchText,
    }
    var response = await TopicApi.GetDescendingTopics(paginationFilter)
    setDescendingTopics(response.data)


    var responseUsers = await UserApi.GetUserDictionaryIds([...response.data.items.map(i => i.studentId!!)])
    var dataUsers: IUserDictionaryModel[] = responseUsers.data
    setUsers(dataUsers)

    if (levelDictionary.length < 1) {
      var responseLevels = await LevelApi.GetLevelDictionary()
      var dataLevels: SelectModel[] = [...responseLevels.data.map(d => ({
        value: d.id.toString(),
        label: d.name
      }))]
      dispatch(level.actions.setLevelDictionary(dataLevels));
    }
  }

  useEffect(() => {
    init()
  }, [refresh, pageNumber, pageSize, searchText, sort])

  return (
    <>
      <GenericTable
        title='Descending Topics'
        data={descendingTopics?.items}
        currentTotalRecords={descendingTopics?.totalRecords!!}
        currentPageNumber={descendingTopics?.pageNumber!!}
        columns={[
          {
            label: '#',
            name: '#',
            options: {
              customBodyRenderLite: (dataIndex) => {
                return <>{(pageNumber - 1) * pageSize + ++dataIndex}</>
              },
              sort: false,
              viewColumns: false,
            },
          },
          {
            label: "Student", name: "studentId", options: {
              customBodyRender: (value) => {
                return <b><Link to={'/account/users/' + value + '/topics'}>{users?.find(i => i.id == value)?.firstName} {users?.find(i => i.id == value)?.lastName}</Link></b>
              }
            }
          },
          {
            label: "Level", name: "levelId", options: {
              customBodyRender: (value) => {
                return <b>{levelDictionary?.find(i => i.value == value)?.label}</b>
              }
            }
          },
          {
            label: 'Remaining Topic',
            name: 'remainingTopicNumber',
          },
          {
            label: '#',
            name: 'Id',
            options: {
              customHeadLabelRender: (options) => {
                return (
                  <div className='d-flex justify-content-end flex-shrink-0'>{options.label}</div>
                )
              },
              customBodyRenderLite: (dataIndex) => {
                return (
                  <TableHelperButtons
                    itemId={descendingTopics?.items[dataIndex]?.id!!}
                    itemParam={descendingTopics?.items[dataIndex]?.id!!}
                    types={[TableHelperButtonEnum.Delete]}
                    onClickItem={onClickItem}
                  />
                )
              },
              filter: false,
              sort: false,
              viewColumns: false,
              searchable: false
            },
          },
        ]}
        customOptions={{
          rowsPerPage: pageSize,
          customTableBodyFooterRender: (opts) => {
            return <div></div>
          },
        }}
        setPageNumber={setPageNumber}
        setPageSize={setPageSize}
        setSearchText={setSearchText}
        setSort={setSort}
      />
    </>
  )
}

export { DescendingTopicListModal }
